export const subcategory = {
  subCategory: 'Subcategorie',
};
